// extracted by mini-css-extract-plugin
module.exports = {"participantList":"styles__participantList___1It-U"};